import { render } from "./UserInfo.vue?vue&type=template&id=5da81a90&ts=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2533167813/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__